import { aiChatsReducer } from "@intelligems/ig-plugin/builder/workflows/ai-chats-reducer";
import { createInitialAiChatState } from "@intelligems/ig-plugin/builder/workflows/initial-state";
import type { AiChatState } from "@intelligems/ig-types/schemas/ai/ai-chat-state";
import type { UiStreamAction } from "@intelligems/ig-types/schemas/ai/ui-stream-actions";
import { createAction, createReducer } from "@reduxjs/toolkit";

import type { ChatSource } from "@src/features/ai/components/WorkflowEditor/execution/types";

/**
 * The audit's conversation, apart from the shared `aiChat`.
 *
 * The other chats are overlays, one open at a time, and each clears the shared
 * chat when it closes. The audit is a whole tab whose conversation has to
 * outlive them, so it keeps its own.
 */
export const auditChatAction = createAction<UiStreamAction | UiStreamAction[]>(
  "opportunityAudit/chat/action"
);
export const auditChatCleared = createAction("opportunityAudit/chat/cleared");

export const opportunityAuditChatReducer = createReducer(
  createInitialAiChatState(),
  (builder) => {
    builder
      .addCase(auditChatCleared, (draft) => {
        Object.assign(draft, createInitialAiChatState());
      })
      .addCase(auditChatAction, (draft, action) => {
        const payload = Array.isArray(action.payload)
          ? action.payload
          : [action.payload];
        for (const item of payload) {
          aiChatsReducer(draft as AiChatState, item);
        }
      });
  }
);

export const getAuditChat = (state: {
  opportunityAuditChat: AiChatState;
}): AiChatState => state.opportunityAuditChat;

export const AUDIT_CHAT: ChatSource = {
  select: getAuditChat,
  apply: auditChatAction,
};
